export const explorers: { [key: number]: string } = {
  0: 'https://etherscan.io',
  1: 'https://etherscan.io',
  30: 'https://explorer.rsk.co',
  31: 'https://explorer.testnet.rsk.co',
  56: 'https://bscxplorer.com',
  97: 'https://testnet.bscscan.com'
};
